import React from 'react';
import moment from 'moment';

const colors = {
    zirconia:  '#c4c4c4',
    prototype: '#000080',
    other: '#00ff00',
    temp: '#a020f0'
};
class ViewToPrint extends React.Component {
    render() {
        return (
            <table className="table table-bordered printingBlockMain" style={{margin: '10px', borderCollapse: 'collapse', border: '1px solid #dee2e6'}}>
                <thead>
                <tr>
                    <th style={{border: '1px solid #dee2e6', padding: '0.8rem'}}>Dentist</th>
                    <th style={{border: '1px solid #dee2e6', padding: '0.8rem'}}>Patient</th>
                    <th style={{border: '1px solid #dee2e6', padding: '0.8rem'}}>Case ID</th>
                    <th style={{border: '1px solid #dee2e6', padding: '0.8rem'}}>Units</th>
                    <th style={{border: '1px solid #dee2e6', padding: '0.8rem'}}>Type</th>
                    <th style={{border: '1px solid #dee2e6', padding: '0.8rem'}}>Appointment</th>
                </tr>
                </thead>
                <tbody>

                {Object.keys(this.props.reportData).sort((a, b) => (moment(a) - moment(b))).map(key => {
                    const data = [];
                    data.push(<tr key={key}>
                        <td style={{fontWeight: 700, textAlign: 'center'}} className="font-weight-bold text-center"
                            colSpan={7}>{moment(key, 'YYYY-MM-DD').format('DD MMMM dddd')} / Booked: {this.props.reportData[key].number_of_units}</td>
                    </tr>);
                    data.push(this.props.reportData[key].bookings.map(item => (
                        <tr key={item.id}>
                            <td style={{border: '1px solid #dee2e6', padding: '0.8rem'}}>{item.doctor}</td>
                            <td style={{border: '1px solid #dee2e6', padding: '0.8rem'}}>{item.patient}</td>
                            <td style={{border: '1px solid #dee2e6', padding: '0.8rem'}}>{item.id}</td>
                            <td style={{border: '1px solid #dee2e6', padding: '0.8rem'}}>{item.units}</td>
                            <td style={{border: '1px solid #dee2e6', padding: '0.8rem'}}>
                                <div style={{padding: '4px',
                                    borderRadius: '4px',
                                    textAlign: 'center',
                                    backgroundColor: colors[item.type],
                                    color: item.type === 'zirconia' ? '#000' : '#fff'
                                }}
                                    className={`${item.type}-case case-type`}>{item.type.charAt(0).toUpperCase() + item.type.slice(1)}</div>
                            </td>
                            <td style={{border: '1px solid #dee2e6', padding: '0.8rem'}}>{item.reportNotes}</td>
                        </tr>)));
                    return data;
                })}
                </tbody>
            </table>
        )
    }
}

export default ViewToPrint;



// WEBPACK FOOTER //
// ./src/components/DailyReport/ViewToPrint.js